import React from "react";
var ErrorExclamation = function (props) {
    return (React.createElement("div", { className: "".concat(props.parentClass ? props.parentClass : "mt-2") },
        React.createElement("div", { className: "invalidMsg ".concat(!props.avoidBackground && "bg_lightPinkTwo change-bg-pastal") },
            React.createElement("div", { className: " ".concat(props.childClass ? props.childClass : "", " DMSansNormal_12_400 txt_bloodRed  d-flex align-items-center") },
                !props.avoidExclamation && (React.createElement("div", { className: "edel-icon-validation" })),
                React.createElement("div", { className: "p-1" }, props.errorMessage)))));
};
export default ErrorExclamation;
